export function absCeil(number) {
    return number < 0 ? Math.floor(number) : Math.ceil(number);
}
//# sourceMappingURL=abs-ceil.js.map


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/~/ngx-bootstrap/chronos/utils/abs-ceil.js
// module id = ../../../../ngx-bootstrap/chronos/utils/abs-ceil.js
// module chunks = 8